import React from "react";
import Grid from "@material-ui/core/Grid";
import DateTime from "./dateTime";
import { apiBatchRequestWithCache } from "../../utils/api_service";
import { API_URL } from "../../constants/api";
import moment from "moment";



class WelComePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
    this.getDataCenterList();
  }

  /**
   * Get data center list
   */
  getDataCenterList = () => {
    apiBatchRequestWithCache([
      {
        url: API_URL.datacenter.getDatacenterList,
        param: {},
        key: "datacenterList",
        fromCache:true,
        duration:15
      },
      {
        url: API_URL.user.GetUserConfigurationDetails,
        param: {},
        key: "userConfigurationDetails",
        // fromCache:true,
        // duration:15
      }
    ]).then(({ datacenterList, userConfigurationDetails }) => {
      // this is settings for the reports

      if (localStorage.getItem("selectedPropertyId") == undefined) {
        localStorage.setItem(
          "selectedPropertyId",
          datacenterList.data[0].propertyID
        );
      }

      if (localStorage.getItem("selectedPropertyIdMultiple") == undefined) {
        localStorage.setItem("selectedPropertyIdMultiple", [
          datacenterList.data[0].propertyID
        ]);
      }

      if (
        localStorage.getItem("selectedPropertyIdMultipleNames") == undefined
      ) {
        localStorage.setItem("selectedPropertyIdMultipleNames", [
          datacenterList.data[0].name
        ]);
      }

      if (localStorage.getItem("Abbreviation") == undefined) {
        localStorage.setItem("Abbreviation", [
          datacenterList.data[0].abbreviation
        ]);
      }

      if (localStorage.getItem("MTDDefault") == undefined) {
        localStorage.setItem("MTDDefault", [moment().format("MM")]);
      }

      localStorage.setItem(
        "userConfiguration",
        JSON.stringify((userConfigurationDetails.data || {}).groups || [])
      );
      //console.log((userConfigurationDetails.data || {}).groups[0].groupName);
      if (userConfigurationDetails.data.groups[0].groupName == "DC_Tenant") {
        //console.log(userConfigurationDetails.data.userInfo.propertyId);
        localStorage.setItem(
          "selectedPropertyId",
          userConfigurationDetails.data.userInfo.propertyId
        );
      }
      
    });
  };
  render() {
    
    return (
      <>
          <Grid container className={"welcome-wrapper"} >
           <DateTime />
          </Grid>
      </>
    );
  }
}

export default WelComePage;
